/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneGhostIcon/view.blocks to change it.
import Children from 'Simple/Children'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneGhostIcon({
  children,
  viewPath = "/DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostIcon",
  disabled,
  marginLeft,
  tabIndex = -1,
  onFocus,
  isShowingOptions,
  onBlur,
  size
  
}) {
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="center"
 size="small"
 type="ghost"
 disabled={disabled}
 marginLeft={marginLeft}
 tabIndex={tabIndex}
 paddingLeft={0}
 paddingRight={0}
 onClick={isShowingOptions ? onBlur : onFocus}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Children
{...childProps}
  viewPath={`${viewPath}/Children`}
 width={size === "small" ? "13px" : size === "tiny" ? "11px" : "15px"}
 height={size === "small" ? "13px" : size === "tiny" ? "11px" : "15px"}
>
{children}
</Children>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</React.Fragment>)
}